"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _appearance_1 = require("./_appearance");
(0, manifest_1.registerSection)({
    type: 'newsletter', label: 'Newsletter', icon: 'mail', category: 'content',
    settingsSchema: zod_1.z.object({
        title: zod_1.z.string().max(160).default('First to the new arrivals.'),
        subtext: zod_1.z.string().max(300).default('One short email a month.'),
        buttonLabel: zod_1.z.string().max(40).default('Subscribe'),
        ..._appearance_1.appearanceShape,
    }),
    defaults: () => ({ title: 'First to the new arrivals.', subtext: 'One short email a month.', buttonLabel: 'Subscribe', ...(0, _appearance_1.appearanceDefaults)() }),
    fields: [
        { name: 'title', label: 'Title', control: 'text', group: 'Content' },
        { name: 'subtext', label: 'Subtext', control: 'textarea', group: 'Content' },
        { name: 'buttonLabel', label: 'Button label', control: 'text', group: 'Content' },
        ..._appearance_1.appearanceFields,
    ],
});
//# sourceMappingURL=newsletter.js.map